import React, { Component } from 'react';
export default class LocationsBranches extends Component {
  
  constructor(props) {
    super(props)
    this.state = {
      flattenedBranches: [],
      filteredBranches: []
    }
    this.filterBranches = this.filterBranches.bind(this);
    this.showBranch = this.showBranch.bind(this);
  }

  componentDidMount() {
    const { branches } = this.props;
    let flattenedBranches = [];
    Object.keys(branches).forEach((key, index) => {
      let loc = branches[key];
      let branchCount = loc['body'].length;
      for(let i = 0; i < branchCount; i++){
        flattenedBranches.push(
          {
            title: loc['body'][i],
            address: loc['address'][i],
            address_city: loc['address_city'],
            location: loc['locations'] && loc['locations'].length >= i ? loc['locations'][i] : null,
            link: loc['link'][i],
            phone: loc['phone'][i],
            pics: loc['pics'][i],
            hidden: loc['hidden']
          }
        );
      }
    })
    flattenedBranches = flattenedBranches.filter(x=> !x.hidden);
    flattenedBranches.sort((a,b) => {
      return a.title < b.title ? -1 : 1;
    });
    this.setState({
      filteredBranches: flattenedBranches,
      flattenedBranches: flattenedBranches
    });
  }
  
  filterBranches(e) {
    const { flattenedBranches } = this.state;
    const searchValue = e.target.value.toLowerCase();
    let filteredBranches = flattenedBranches.filter(branch =>
      branch['address'].toLowerCase().includes(searchValue) ||
      (typeof branch['address_city'] === 'string' && branch['address_city'].toLowerCase().includes(searchValue)) ||
      branch['phone'].toLowerCase().includes(searchValue) ||
      branch['title'].toLowerCase().includes(searchValue)
    );
    this.setState({
      filteredBranches: filteredBranches
    });
  }

  showBranch(branch) {
    if(this.props.setSelectedBranch) {
      this.props.setSelectedBranch(branch);
    }
  }

  goToBranch(branch) {
    location.href = `location/${branch.link}`
  }

  renderBranches() {
    const { arrow_right_image } = this.props;
    const { filteredBranches } = this.state;
    const renderedBranches = filteredBranches.map( branch =>
      <div
        onClick={()=>{
          this.showBranch(branch)
        }}
        className="locations-branch-wrapper"
        key={`branch-${branch.title}`}
      >
        <div className="locations-branch-text">
          <b
            onClick={() => this.goToBranch(branch)}
          >{branch.title}</b>
          <br />
          {branch.address}
          <br />
          {branch.address_city}
          <br />
          {branch.phone}
        </div>
        <div onClick={() => this.goToBranch(branch)} className="locations-branch-arrow">
          <img src={arrow_right_image} />
        </div>
      </div>
    )
    return renderedBranches;
  }

  render() {
    const { search_image } = this.props;
    return (
      <>
        <div className="locations-branches-search-bar">
          <img src={search_image}/>
          <input type="text" onChange={this.filterBranches}/>
        </div>
        <div className="locations-branches-wrapper">
          {this.renderBranches()}
        </div>
      </>
    )
  }
}
